import React, { useState, useCallback, useEffect, useMemo } from "react";
import backIcon from "../../../../img/Arrow.png";
import editIcon from "../../../../img/icon-edit.png";
import locateIcon from "../../../../img/location-icon.png";
import rightChevronIcon from "../../../../img/right-chevron.png";
import tickIcon from "../../../../img/icon-tick.png";
import gPayIcon from "../../../../img/gPay.png";
import visaIcon from "../../../../img/icon-visa.png";
import paymentIcon from "../../../../img/icon-payment.png";
import varifiedIcon from "../../../../img/icon-varified.png";
import paytmIcon from "../../../../img/icon-paytm.png";
import phonepeIcon from "../../../../img/icon-phonepe.png";
import bhimIcon from "../../../../img/icon-bhim.png";
import AddAddress from "../../../../Store/Cart/Components/Modals/AddAddress";
import useHttp from "../../../../Request/use-http";
import { onlinePaymentDetails } from "../../../../Redux/Actions/userActions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import Loading from "../../../../Others/Loading";
const url = process.env.React_App_Api_url;

const getPaytmTokenFX = async (amount) => {
  try {
    const response = await fetch(`${url}/paytm`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ amount: amount, orderId: "Ord_" + Date.now() }),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
  }
};

const AddressPage = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  //STATES
  const [newAddressNeeded, setnewAddressNeeded] = useState(true);
  const [paymentMethod, setPaymentMethod] = useState("Pay on Delivery");
  const [underPaymentProcess, setUnderPaymentProcess] = useState(false);
  const paymentDetails = useSelector(
    (state) => state.user.onlinePaymentDetails
  );

  const user = useSelector((state) => state.user?.info);
  const userAddress = useSelector((state) => state.user?.address);
  const bill = useSelector((state) => state.user?.bill);

  const primaryAddress = useMemo(
    () =>
      userAddress?.filter((address) => {
        if (address.primary) {
          return address;
        }
      }),
    [userAddress]
  );

  const getPaytmToken = (amount) => {
    setUnderPaymentProcess(true);
    getPaytmTokenFX(amount).then((data) => {
      const { orderid: orderId, txntoken: txnToken, amount } = data.data;
      localStorage.setItem("OID", orderId);
      dispatch(
        onlinePaymentDetails({
          paytmOrderId: orderId,
        })
      );
      var config = {
        root: "",
        flow: "DEFAULT",
        data: {
          orderId: orderId,
          token: txnToken,
          tokenType: "TXN_TOKEN",
          amount: amount,
        },
        merchant: {
          redirect: true,
        },
        handler: {
          notifyMerchant: function (eventName, data) {
            // console.log("notifyMerchant handler function called");
            // console.log("eventName => ", eventName);
            // console.log("data => ", data); //data coming as undefined
          },
        },
      };
      if (window.Paytm && window.Paytm.CheckoutJS) {
        // initialze configuration using init method
        window.Paytm.CheckoutJS.init(config)
          .then(function onSuccess() {
            // after successfully updating configuration, invoke checkoutjs
            window.Paytm.CheckoutJS.invoke();
            navigation("/payment-await", { replace: true });
          })
          .catch(function onError(error) {
            console.log("error => ", error);
          });
      }
    });
  };
  //HEADER BACK BUTTON FX
  const headerBackButtonFX = useCallback(() => {
    if (newAddressNeeded) {
      setnewAddressNeeded(false);
      return;
    }
    navigation(-1, { replace: true });
  }, [newAddressNeeded]);
  //
  //CHANGE PAYMENT METHOD FX
  const changePaymentMethodFX = useCallback(
    (action) => {
      setPaymentMethod(action);
    },
    [paymentMethod]
  );
  //
  //CONTINUE WITH PAYMENT
  const continueWithPayment = useCallback(() => {
    dispatch(
      onlinePaymentDetails({
        paymentMethod: paymentMethod,
      })
    );
    switch (paymentMethod) {
      case "Pay on Delivery":
        navigation("/place-order", {
          replace: true,
        });
        return;
      case "PayTM":
        if (bill?.Total) {
          getPaytmToken(bill?.Total);
        }
        //navigate to paytm gateway

        return;
      default:
        return;
    }
  }, [paymentMethod]);
  //
  useEffect(() => {
    if (primaryAddress?.length > 0) {
      setnewAddressNeeded(false);
    } else if (!primaryAddress) {
      setnewAddressNeeded(true);
    }
    // console.log(primaryAddress);
  }, [userAddress]);

  if (underPaymentProcess) {
    return <Loading />;
  }

  return newAddressNeeded ? (
    <div
      style={{
        background: "#F4F5F7",
        minHeight: "100vh",
        paddingBottom: "125px",
        paddingTop: "51px",
      }}
    >
      <Header headerBackButtonFX={headerBackButtonFX} />

      <AddressForm
        title={"Add New Address"}
        setnewAddressNeeded={setnewAddressNeeded}
      />
    </div>
  ) : (
    <div
      style={{
        background: "#F4F5F7",
        minHeight: "100vh",
        paddingBottom: "67px",
        paddingTop: "51px",
      }}
    >
      <Header headerBackButtonFX={headerBackButtonFX} />

      <UserAddress
        primaryAddress={primaryAddress[0]}
        setnewAddressNeeded={setnewAddressNeeded}
      />
      {/* PAYTM BUTTON DISABLED---------------------------------------- */}
      <div className="bg-white address-card payMetohds">
        <div className="d-flex align-items-center justify-content-between sec-title">
          <h2 style={{ margin: "0" }}>Preferred payment method</h2>
        </div>
        <div
          className="d-flex align-items-center addCard-item"
          onClick={() => changePaymentMethodFX("PayTM")}
        >
          <div className="addCard-img ">
            <img src={paytmIcon} alt="locateIcon" width={26} />
          </div>
          <div>
            <h4>PayTM</h4>
          </div>
          <div
            className={`ms-auto paytick ${
              paymentMethod === "PayTM" ? "active" : ""
            }`}
          >
            <img src={tickIcon} alt="tickIcon" width={13} />
          </div>
        </div>
        {/* MULTI UPI PAYMENT OPTIONS */}
        {/* <div className="paymethod-card">
          <div className="d-flex justify-content-between">
            <div>
              <div className="addCard-img">
                <img src={gPayIcon} alt="locateIcon" width={32} />
              </div>
              <h5>Google pay</h5>
            </div>
            <div>
              <div className="addCard-img">
                <img src={paytmIcon} alt="locateIcon" width={30} />
              </div>
              <h5>Paytm</h5>
            </div>
            <div>
              <div className="addCard-img">
                <img src={phonepeIcon} alt="locateIcon" width={25} />
              </div>
              <h5>PhonePe</h5>
            </div>
            <div>
              <div className="addCard-img">
                <img src={bhimIcon} alt="locateIcon" width={30} />
              </div>
              <h5>BHIM</h5>
            </div>
          </div>
          <div
            style={{
              padding: "12px 0",
              fontSize: "12px",
              color: "rgba(43, 43, 43, 0.5)",
            }}
          >
            or
          </div>
          <div className="method-input" style={{ marginBottom: "0" }}>
            <input
              type="text"
              id="upiId"
              className="form-control"
              onChange=""
            />
            <label for="upiId">Enter UPI ID</label>
          </div>
        </div> */}
      </div>
      {/* PAY WITH CARD */}
      {/* <div className="bg-white address-card payMetohds">
        <div className="d-flex align-items-center justify-content-between sec-title">
          <h2 style={{ margin: "0" }}>Card Payment</h2>
        </div>
        <div className="d-flex align-items-center addCard-item">
          <div className="addCard-img">
            <img src={visaIcon} alt="visaIcon" width={26} />
          </div>
          <div>
            <h4>Credit/Debit card</h4>
          </div>
          <div className="ms-auto paytick">
            <img src={tickIcon} alt="tickIcon" width={13} />
          </div>
        </div>
      </div> */}
      <div className="bg-white address-card payMetohds">
        <div className="d-flex align-items-center justify-content-between sec-title">
          <h2 style={{ margin: "0" }}>Other Payment Options</h2>
        </div>
        <div
          className="d-flex align-items-center addCard-item"
          onClick={() => changePaymentMethodFX("Pay on Delivery")}
        >
          <div className="addCard-img">
            <img src={paymentIcon} alt="paymentIcon" width={15} />
          </div>
          <div>
            <h4>Pay on Delivery</h4>
          </div>
          <div
            className={`ms-auto paytick ${
              paymentMethod === "Pay on Delivery" ? "active" : ""
            }`}
          >
            <img src={tickIcon} alt="tickIcon" width={13} />
          </div>
        </div>
      </div>
      <div style={{ padding: "16px", textAlign: "center" }}>
        <div className="d-flex justify-content-center">
          <img src={varifiedIcon} alt="varifiedIcon" width={24} />
        </div>
        <p
          style={{
            fontSize: "14px",
            fontWeight: "400",
            color: "#2B2B2B",
            margin: "8px 0 0",
          }}
        >
          100% secure payment
        </p>
      </div>
      {/* SAVE AND CONTINUE BUTTON */}
      <div className="bottom-bar">
        <div style={{ marginTop: "8px", borderRadius: "8px 8px 0 0" }}>
          <button
            type="button"
            className="btn w-100 btn-orange text-orange"
            onClick={continueWithPayment}
          >
            Save &amp; Continue
          </button>
        </div>
      </div>
    </div>
  );
};

//common components
const Header = React.memo(({ headerBackButtonFX }) => {
  return (
    <div
      style={{
        padding: "13.5px 16px",
        boxShadow: "0px 1px 0px rgba(0, 0, 0, 0.11)",
      }}
      className="fixed-top d-flex align-items-center transition text-orange bg-white "
    >
      <div
        className="text-center my-auto"
        style={{ paddingRight: "8px" }}
        onClick={headerBackButtonFX}
      >
        <img src={backIcon} alt="" width={24} />
      </div>
      <div className="w-100 my-auto overflow-hidden">
        <h2
          style={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            fontSize: "16px",
            margin: "0",
            color: "#2b2b2b",
            fontWeight: "700",
          }}
        >
          Address & Payment
        </h2>
      </div>
    </div>
  );
});

const AddressForm = ({ title, setnewAddressNeeded }) => {
  return (
    <div className="bg-white address-card">
      <div className="d-flex align-items-center justify-content-between sec-title">
        <h2 style={{ margin: "0" }}>{title}</h2>
      </div>

      <AddAddress setnewAddressNeeded={setnewAddressNeeded} />
    </div>
  );
};

//RTU ADDRESS
const UserAddress = ({ primaryAddress, setnewAddressNeeded }) => {
  return (
    <div
      className="bg-white address-card"
      onClick={() => setnewAddressNeeded(true)}
    >
      <div className="d-flex align-items-center justify-content-between sec-title">
        <h2 style={{ margin: "0" }}>Delivery Address</h2>
        <div className="d-flex align-items-center badge badge-success">
          <img
            src={editIcon}
            alt="IconBag"
            width={12}
            style={{ marginRight: "6px", marginBottom: "1px" }}
          />
          CHANGE
        </div>
      </div>
      <div className="d-flex align-items-center addCard-item">
        <div className="addCard-img">
          <img src={locateIcon} alt="locateIcon" width={20} />
        </div>
        <div>
          <h4>
            {primaryAddress?.area}, {primaryAddress?.state}
          </h4>
          <h5>{primaryAddress?.address}</h5>
        </div>
        <div className="ms-auto ps-3">
          <img src={rightChevronIcon} alt="rightChevronIcon" width={20} />
        </div>
      </div>
    </div>
  );
};

//edit existing address
const EditAddress = () => {
  return (
    <div className="bg-white address-card">
      <div className="d-flex align-items-center justify-content-between sec-title">
        <h2 style={{ margin: "0" }}>Delivery Address</h2>
      </div>
      <div className="d-flex align-items-center addCard-item">
        <div className="addCard-img">
          <img src={locateIcon} alt="locateIcon" width={20} />
        </div>
        <div>
          <h4>Omaxe City, Haryana</h4>
          <h5>KIAL Road, Bevanhalli, Harayana...</h5>
        </div>
        <div className="ms-auto paytick active">
          <img src={tickIcon} alt="tickIcon" width={13} />
        </div>
      </div>
      <div
        className="d-flex justify-content-stretch align-items-center"
        style={{ margin: "16px 0 -10px" }}
      >
        <button
          type="button"
          className="btn flex-fill"
          style={{ color: "#BE2323", fontWeight: "500" }}
          data-bs-toggle="modal"
          data-bs-target="#deleteAddressModal"
        >
          Delete Address
        </button>
        <div
          style={{
            height: "24px",
            width: "1px",
            background: "rgba(200, 200, 200, 0.5)",
          }}
        ></div>
        <button
          type="button"
          className="btn flex-fill"
          style={{ color: "#2278FF", fontWeight: "500" }}
        >
          Edit Address
        </button>
      </div>
      {/* ADD NEW ADDRESS */}
      <div>
        <button
          type="button"
          className="btn w-100 text-orange"
          style={{
            fontSize: "16px",
            lineHeight: "22px",
            fontWeight: "600",
          }}
        >
          <span style={{ fontSize: "22px", position: "relative", top: "1px" }}>
            +
          </span>
          Add new Address
        </button>
      </div>
      {/* SAVE AND CONTINUE BUTTON */}
      <div className="bottom-bar">
        <div style={{ marginTop: "8px", borderRadius: "8px 8px 0 0" }}>
          <button
            type="button"
            className="btn w-100 btn-orange text-orange"
            disabled
          >
            Save &amp; Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddressPage;
